// extracted by css-extract-rspack-plugin
export default {"removeButton":"remove-button--E04n8Rsp_Coii7mo"};